var _g, _g2, _g3, _g4, _path, _g5, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgTop2Big = function SvgTop2Big(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 47,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#Top2_big_svg__v7v569xeea)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.655 6.977h-.131c-4.215 0-7.634-.22-7.634 3.921 0 4.14 3.419 11.077 7.634 11.077h.131c1.495 0 2.704-1.189 2.704-2.657V9.633c0-1.465-1.21-2.656-2.704-2.656zm32.6 0h-.13c-1.495 0-2.705 1.188-2.705 2.656v9.682c0 1.468 1.21 2.656 2.705 2.656h.13c4.216 0 7.635-6.935 7.635-11.076 0-4.138-3.416-3.918-7.634-3.918z",
    fill: "#DEDEDE"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#Top2_big_svg__np33cs05hb)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#DEDEDE",
    d: "M22.222 31.975h6v12h-6z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#Top2_big_svg__ymz1n06uqc)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10.222,
    y: 40.975,
    width: 30,
    height: 6,
    rx: 3,
    fill: "#DEDEDE"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#Top2_big_svg__llzd5klfyd)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.333 0H14.27c-3.524 0-6.38 2.602-6.38 5.812v13.144c0 8.76 7.796 15.863 17.41 15.863 9.615 0 17.41-7.103 17.41-15.863V5.81c0-3.208-2.855-5.81-6.376-5.81z",
    fill: "url(#Top2_big_svg__xuz9xwpi5e)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "Top2_big_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 0,
    width: 35,
    height: 35
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.444 0H14.378C10.856 0 8 2.602 8 5.812v13.144c0 8.76 7.795 15.863 17.41 15.863 9.614 0 17.41-7.103 17.41-15.863V5.81c0-3.208-2.856-5.81-6.377-5.81z",
    fill: "url(#Top2_big_svg__kiyqk6246f)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#Top2_big_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#Top2_big_svg__8vv9xefhnh)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.264 28.235C9.36 29.895 9.802 10.1 12.01-.005l19.88-1.662c-2.485 5.814-7.29 19.934-6.627 29.902z",
    fill: "#F9F8F4",
    fillOpacity: 0.49
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#Top2_big_svg__j1k3gauo8i)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.571 28.588c15.542 3.76 17.734-15.92 16.888-26.23L35.975-1.928c1.69 6.093 4.576 20.727 2.595 30.517z",
    fill: "#D3CCC9"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#Top2_big_svg__5vokjaqztj)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.365 31.938c-3.178 15.671 16.57 17.129 26.84 15.899l3.56-19.629c-6.026 1.916-20.542 5.345-30.4 3.73z",
    fill: "#8F8682"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#Top2_big_svg__wzco1euu6k)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.765 26a1 1 0 001-1v-1.26a1 1 0 00-1-1h-5.613a.4.4 0 01-.306-.656l4.854-5.778c1.331-1.587 2.065-2.618 2.065-4.54C30.765 8.201 28.32 6 24.896 6c-2.998 0-5.396 1.778-5.827 4.797-.078.547.379.997.931.997h1.532c.553 0 .974-.46 1.13-.989.34-1.15 1.296-1.546 2.234-1.546 1.494 0 2.337 1.003 2.337 2.48 0 .918-.3 1.531-1.006 2.395l-6.993 8.328a1 1 0 00-.234.643V25a1 1 0 001 1h9.765z",
    fill: "url(#Top2_big_svg__21s80gp6hl)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Top2_big_svg__v7v569xeea",
    x: 0.89,
    y: 6.975,
    width: 48,
    height: 15,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_4982_277882"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Top2_big_svg__np33cs05hb",
    x: 22.222,
    y: 31.975,
    width: 6,
    height: 12,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_4982_277882"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Top2_big_svg__ymz1n06uqc",
    x: 10.222,
    y: 40.975,
    width: 30,
    height: 6,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_4982_277882"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Top2_big_svg__llzd5klfyd",
    x: 4.89,
    y: -2,
    width: 37.819,
    height: 36.819,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -3,
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.733333 0 0 0 0 0.722639 0 0 0 0 0.721111 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_4982_277882"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.84 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_innerShadow_4982_277882",
    result: "effect2_innerShadow_4982_277882"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Top2_big_svg__8vv9xefhnh",
    x: -0.11,
    y: -12.667,
    width: 43,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.5,
    result: "effect1_foregroundBlur_4982_277882"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Top2_big_svg__j1k3gauo8i",
    x: 24.976,
    y: -12.929,
    width: 41.638,
    height: 52.988,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.5,
    result: "effect1_foregroundBlur_4982_277882"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Top2_big_svg__5vokjaqztj",
    x: 0.023,
    y: 17.208,
    width: 52.741,
    height: 41.966,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.5,
    result: "effect1_foregroundBlur_4982_277882"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Top2_big_svg__wzco1euu6k",
    x: 17,
    y: 5,
    width: 15.765,
    height: 24,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.658824 0 0 0 0 0.619608 0 0 0 0 0.6 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4982_277882"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4982_277882",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Top2_big_svg__xuz9xwpi5e",
    x1: 34.834,
    y1: 17.333,
    x2: 12.834,
    y2: 17.333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5B9BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFB6B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Top2_big_svg__kiyqk6246f",
    x1: 34.945,
    y1: 17.333,
    x2: 12.945,
    y2: 17.333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8C0C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9CFD1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Top2_big_svg__21s80gp6hl",
    x1: 24.75,
    y1: 13,
    x2: 24.883,
    y2: 26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3E2E1"
  })))));
};

export default SvgTop2Big;